import { Alert } from '@mui/material';
import type { FHRequest } from '../types';

interface RecurringTaskBannerProps {
  request: FHRequest;
}

function describeFrequency(frequency: string): string {
  const f = frequency?.toLowerCase();
  if (f === 'daily') return 'daily';
  if (f === 'weekdays' || f === 'week days') return 'weekday';
  if (f === 'weekly') return 'weekly';
  if (f === 'monthly') return 'monthly';
  return 'recurring';
}

export const RecurringTaskBanner = ({ request }: RecurringTaskBannerProps) => {
  if (!request.is_recurring || !request.recurring_info) {
    return null;
  }

  const { next_date, frequency } = request.recurring_info;
  const freqLabel = describeFrequency(frequency);

  // Format the next date for display
  let formattedDate = 'an upcoming date';
  if (next_date) {
    try {
      formattedDate = new Date(next_date).toLocaleDateString(undefined, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    } catch {
      formattedDate = next_date;
    }
  }

  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      This is a {freqLabel} recurring task. It will automatically get resubmitted on{' '}
      <strong>{formattedDate}</strong> as a normal task. So don't worry if the
      client mentions redoing this in the future.
    </Alert>
  );
};
